/** Gợi ý câu hỏi ở màn trống của bubble Action Plan V2 — theo vai trò (quyền ghi theo cơ cấu). */
export function actionPlanAiSuggestions(role: { isAdmin?: boolean; isQuanLy?: boolean } | null | undefined): string[] {
  const base = ['Việc nào của tôi đang quá hạn?', 'Tạo việc mới cho tôi'];
  if (role?.isAdmin || role?.isQuanLy) {
    return [
      ...base,
      'Giao việc cho nhân viên trong phòng',
      'Ai trong phòng trễ hạn nhiều nhất?',
    ];
  }
  return [...base, 'Liệt kê việc gốc tôi đang phụ trách', 'Đổi hạn một việc của tôi'];
}
